import { STATE } from './constants'

export const setScrollAction = payload => ({ type: STATE, payload })

export const setScroll = data => dispatch => dispatch(setScrollAction(data))
